import { createContext, useEffect, useState } from "react";

export const LocalStorageContext = createContext<[number, () => void]>([
    0,
    () => {}
]);

// To use this provider you pass it a unique sting that it can use to determine the modal that is open
export const LocalStorageProvider = ({ children }: any) => {
  const [syncCounter, setSyncCounter] = useState<number>(0);

  const refreshLocalStorage = (): void => {
    setSyncCounter((prevCounter) => {
      return prevCounter + 1;
    });
  }

  return (
    <LocalStorageContext.Provider value={[syncCounter, refreshLocalStorage]}>
      {children}
    </LocalStorageContext.Provider>
  );
};
